var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_qr_code"},[_c('div',{staticClass:"banner"},[(_vm.type === 'img')?_c('img',{ref:"qrcode",attrs:{"src":_vm.imgUrl,"alt":""}}):_c('canvas',{ref:"qrcode",staticClass:"qrcode"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }